import {useEffect} from 'react';

import {LearnerInfo, USER_ROLES} from '../../types';
import {isSubscriptionOwnerInfo, updateUserComPlanInfo} from '../helpers';
import {useSubscriptionInfo} from '../hooks';

const useUpdateUserComSubInfo = (userInfo?: LearnerInfo | null) => {

  const { loadSubInfo, subInfo } = useSubscriptionInfo();

  //fetch subscription info after authorization
  useEffect(() => {
    if (userInfo?.role && Object.values(USER_ROLES).includes(userInfo.role as USER_ROLES)) {
      loadSubInfo(userInfo.role as USER_ROLES);
    }
  }, [userInfo, loadSubInfo]);

  useEffect(() => {
    if (subInfo?.type || subInfo?.renews_automaticly_on) {
      const subOwnerInfo = isSubscriptionOwnerInfo(subInfo);
      updateUserComPlanInfo({
        plan: subInfo?.type,
        planType: subInfo?.subscription_group_type,
        renewDate: subInfo?.renews_automaticly_on,
        trialLeft: subOwnerInfo ? subOwnerInfo?.remaining_trials?.left : 0,
        userInfo,
      });
    }
  }, [subInfo, userInfo]);
};

export default useUpdateUserComSubInfo;
